// Class: motion.easing._Back.BackEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var BackEaseIn = function(s) {
	this.s = s;
}

// Meta

BackEaseIn.__name__ = ["motion","easing","_Back","BackEaseIn"];
BackEaseIn.__isInterface__ = false;
BackEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
BackEaseIn.prototype = {
	calculate: function(k) {
		return k * k * ((this.s + 1) * k - this.s);
	},
	ease: function(t,b,c,d) {
		return c * (t /= d) * t * ((this.s + 1) * t - this.s) + b;
	}
};
BackEaseIn.prototype.__class__ = BackEaseIn.prototype.constructor = $hxClasses["motion.easing._Back.BackEaseIn"] = BackEaseIn;

// Init



// Statics




// Export

exports.default = BackEaseIn;